import { render, staticRenderFns } from "./ModanisaKategori.vue?vue&type=template&id=44acf167&scoped=true"
import script from "./ModanisaKategori.vue?vue&type=script&lang=js"
export * from "./ModanisaKategori.vue?vue&type=script&lang=js"
import style0 from "./ModanisaKategori.vue?vue&type=style&index=0&id=44acf167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44acf167",
  null
  
)

export default component.exports